import { setActivePage } from "context";
import { setAssignTo } from "context";
import { useMaterialUIController } from "context";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

const EamsEventAction = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage } = controller;
  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.eventType === "AlertHistory") {
        activePage.key = "configuration.nms-alert-history";
        activePage.name = "Nms-Alert-History";
        activePage.url = "home/app/configurations/nms-alert-history";
        activePage.description = "Nms-Alert-History";
        setActivePage(dispatch, activePage);
      } else if (event?.data?.eventType === "Escalation") {
        activePage.key = "escalationDetails";
        activePage.name = "Escalation Details";
        activePage.url = "home/app/escalation-details";
        activePage.description = "";
        setActivePage(dispatch, activePage);
      } else if (event?.data?.eventType === "dashboard") {
        setAssignTo(dispatch, event?.data?.data);
        activePage.key = "dashboard.controller";
        activePage.name = "dashboardController";
        activePage.url = "/app/dashboardController/home";
        activePage.description = "Dashboard Controller";
      } else {
        console.log("error while the call GUI");
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [activePage, dispatch, Navigate]);

  return <></>;
};
export default EamsEventAction;
